import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Roles from '../resources/UserRole';
import ClaimService from '../services/ClaimService';
import Notifications from "../services/Notifications";
import Claims from './claims/Claims';
import ClaimsFilter from './claims/ClaimsFilter';
import NonFastTrackModal from './claims/NonFastTrackModal';
import ClaimsSubmission from './claims/ClaimsSubmission';
import DateHelper from '../helpers/DateHelper';
import UserHelper from '../helpers/UserHelper';
import { withSelectedCustomer } from '../hooks/withSelectedCustomer';
import { withStorefrontConfig } from '../hooks/StorefrontSettingsContext';
import { withWarrantyConfig } from '../hooks/WarrantyConfigContext';
import NotificationBanner from "./banner/NotificationBanner";import Survey from "./survey/Survey";
import { useTheme, useMediaQuery } from '@mui/material';



const getStringDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

export const ClaimHistory = (props) => {
    const localized = props.WarrantyConfig.labels;
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [fromFullDate, setFromFullDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
    const [toFullDate, setToFullDate] = useState(new Date());
    const [selectedStatuses, setSelectedStatuses] = useState([]);      
    const [numberFilter, setNumberFilter] = useState('');              
    const [availableStatuses, setAvailableStatuses] = useState([]);    
    const theme = useTheme();
    const listView = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    const [statusCodes, setStatusCodes] = useState([]);
    const [claimsStatus, setClaimsStatus] = useState([]);
    const [isClaimSubmitted, setIsClaimSubmitted] = useState(false);
    const feature = 'w';
    const [fullName, setFullName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [customerNumber, setCustomerNumber] = useState("");
    const [branchPlant, setBranchPlant] = useState("");
    const [approvalStatus, setApprovalStatus] = useState("");
    const [count, setCount] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [customerId, setCustomerId] = useState(props && props.selectedCustomer ? props.selectedCustomer.id : null);
    const [billToCustomer, setBillToCustomer] = useState(props && props.selectedCustomer ? props.selectedCustomer.billToId : null);
    const [storefrontId, setStorefrontId] = useState(props && props.currentUser.storefrontId);

    // Pending Claims added from form
    const [claims, setClaims] = useState(null);
    const [addingItem, setAddingItem] = useState(false);

    // State Passed To ClaimsSubmission Start
    const [claimLines, setClaimLines] = useState([]);
    const [stockingType, setStockingType] = useState([]);
    const [returnPolicy, setReturnPolicy] = useState(false);
    const [obsolete, setObsolete] = useState(false);
    const [duplicateSerial, setDuplicateSerial] = useState(false);
    const [isPioneerItem, setIsPioneerItem] = useState(false);
    const [pioneerBrand, setPioneerBrand] = useState({});
    const [itemDispositions, setItemDispositions] = useState([]);
    const [productType, setProductType] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [warrantyDescription, setWarrantyDescription] = useState("");

    // Validation
    const [isValidClaim, setIsValidClaim] = useState(false);
    const [claimApproval, setClaimApproval] = useState([]);

    // Errors
    const [serialNumberErrors, setSerialNumberErrors] = useState(false);
    const [claimTypeOptionError, setClaimTypeOptionError] = useState(false);
    const [referenceNumberError, setReferenceNumberError] = useState(false);
    const [itemNumberError, setItemNumberError] = useState(null);
    const [installDateError, setInstallDateError] = useState(false);
    const [failureDateError, setFailureDateError] = useState(false);
    const [loyalityIDWarning, setLoyalityIDWarning] = useState({ isNumber: true, loyaltyID: null });
    const [serialNumberWarning, setSerialNumberWarning] = useState(false);
    const [fastTrackError, setFastTrackError] = useState(false);
    const [illegitimateSerialNumber, setIllegitimateSerialNumber] = useState(false);
    const [hasWarrantyAllowanceError, setWarrantyAllowanceError] = useState(false);

    // Upload Files
    const [uploadFiles, setUploadFiles] = useState([]);

    // Input Form Values
    const [itemNumberSubmit, setItemNumberSubmit] = useState("");
    const [hasCustomerWarrantyAllowance, setHasCustomerWarrantyAllowance] = useState(false);
    const [serialNumberSubmit, setserialNumberSubmit] = useState("");
    const [loyaltyIDSubmit, setLoyaltyIDSubmit] = useState("");
    const [referenceNumberSubmit, setReferenceNumberSubmit] = useState("");
    const [claimType, setClaimType] = useState("");
    const [detailsCommentSubmit, setDetailsCommentSubmit] = useState("");
    const [dateFailedSubmit, setDateFailedSubmit] = useState("");
    const [dateInstalledSubmit, setDateInstalledSubmit] = useState("");
    const [pumpManufacturer, setPumpManufacturer] = useState("");
    const [failureType, setFailureType] = useState({ selected: "", isCommentsRequired: true });
    const [isMissingSerial, setIsMissingSerial] = useState(false);
    const [isSerialNumberBypass, setIsSerialNumberBypass] = useState(false);
    const [recommendedItemNumber, setRecommendedItemNumber] = useState(null);

    // Edit Mode
    const [isEditMode, setIsEditMode] = useState(false);
    const [serialNumberBeingEdited, setSerialNumberBeingEdited] = useState(null);

    const [canApproveRejectClaim, setCanApproveRejectClaim] = useState(
        props.currentUser.roles.includes(Roles.CAN_APPROVE_REJECT_CLAIM)
            ? true
            : false
    );
    const [showNonFastTrackModal, setShowNonFastTrackModal] = useState(false);
    const [allowReplacement, setAllowReplacement] = useState(false);
    const [serialNumberClassName, setSerialNumberClassName] = useState("");
    const [allDispositions, setAllDispositions] = useState([]);
    const UniqueWarrantyConstants = props.WarrantyConfig.uniqueWarrantyConstants.filter(x => x.serialConsideration).map(x => x.sku.toUpperCase()) ?? [];

    const validationResponseMessages = {
        "GenericError": localized.GenericError,
        "InvalidSerialNumber": localized.InvalidSerialNumber,
        "MissingSerialNumber": localized.MissingSerialNumber,
        "MissingItemNumber": localized.MissingItemNumber,
        "HasWarrantyAllowance": localized.HasWarrantyAllowance
    };
    const dateFormat = props.StorefrontConfig.settingsList.DateFormat ? props.StorefrontConfig.settingsList.DateFormat : "MM/dd/yyyy";

    const fetchCustomerWarrantyAllowance = async () => {
        const hasWarrantyAllowance = await ClaimService.fetchCustomerWarrantyAllowance(props.selectedCustomer.billToId);
        setHasCustomerWarrantyAllowance(hasWarrantyAllowance);
    }

    const fetchClaimDispositions = async () => {
        if (props?.selectedCustomer) {
            try {
                const storefrontId_1 = storefrontId || props.currentUser.storefrontId;
                const dispositions = await ClaimService.fetchDispositions(storefrontId_1);
                if (dispositions) setAllDispositions(dispositions);
            } catch (error) {
                console.error("Error fetching claim dispositions:", error);
            }
        }
    };

    const fetchStatusCodes = async () => {
        if (props.selectedCustomer) {
            try {
                const statusCodes = await ClaimService.fetchStatusCodes();
                setStatusCodes(Array.isArray(statusCodes) ? statusCodes : []);
            }
            catch (error) {
                console.error("Error fetching status codes:", error);
                setStatusCodes([]);
            }
        }
    };

    const fetchClaimsStatus = async () => {
        if (props.selectedCustomer) {
            try {
                const storefrontId_1 = storefrontId || props.currentUser.storefrontId;
                const cs = await ClaimService.fetchClaimsStatus(storefrontId_1);
                setClaimsStatus(Array.isArray(cs?.warrantyClaimStatus) ? cs.warrantyClaimStatus : []);
            } catch (error) {
                console.error("Error fetching claims status:", error);
                setClaimsStatus([]);
            }
        }
    };

    const resetChanges = () => {
        clearForm();
        setClaimLines([]);
        setClaimApproval([]);
        if (claims?.length > 0) {
            const claimsApprovalData = claims.map(claim => {
                return { ...claim, approvalStatus: '' };
            });
            setClaims(claimsApprovalData);
        }
    };

    const fetchData = async () => {
        if (props?.selectedCustomer?.id) {
            setCustomerId(props?.selectedCustomer?.id);
            setBillToCustomer(props?.selectedCustomer?.billToId);
            resetChanges();
            await Promise.all([
                fetchClaimsStatus(),
                fetchStatusCodes(),
                fetchClaimDispositions(),
                fetchCustomerWarrantyAllowance()
            ]);
        }
    };

    useEffect(() => {
        fetchData();
    }, [props?.selectedCustomer?.id]);

    const buildClaimQueryState = () => {
        const msPerDay = 24 * 60 * 60 * 1000;
        const computedRange = Math.max(1, Math.round((toFullDate - fromFullDate) / msPerDay));



        const statusDescription =
              Array.isArray(selectedStatuses)
                    ? (selectedStatuses[0]?.label ?? selectedStatuses[0]?.value ?? '')
                : (selectedStatuses?.label ?? selectedStatuses ?? '');
        return {
            page: paginationModel.page + 1,
            pageSize: paginationModel.pageSize,
            fromDate: getStringDate(fromFullDate),
            toDate: getStringDate(toFullDate),
            dateRange: String(computedRange),
            statusDescription,
            searchValue: numberFilter,
            customerId,
            billToCustomer,
            storefrontId
        };
    };

    const fetchClaims = async () => {
        if (!props.selectedCustomer) return;
        try {
            setFetching(true);
            const query = buildClaimQueryState();
            const claimsData = await ClaimService.fetchClaims(query, props);
            loaded(claimsData);
        } catch (error) {
            console.error("Error fetching claims:", error);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        if (!customerId) return;
        fetchClaims();
    }, [paginationModel, fromFullDate, toFullDate, selectedStatuses, numberFilter, customerId]);


    const loaded = (data) => {
        if (data) {
            setFetching(false);
            setClaims(data.warrantyClaims);
            setCount(data.totalCount);
        }

        const pairs = Array.from(
              new Map(
                    (data?.warrantyClaims ?? []).map(o => [
                        String(o.statusCode),
                        { value: String(o.statusCode), label: o.statusDescription ?? String(o.statusCode) }
                        ])
                  ).values()
            );
        setAvailableStatuses(prev => {
            const dedup = new Map([
                ...(prev ?? []).map(p => [String(p.value), { ...p, value: String(p.value) }]),
                ...pairs.map(p => [String(p.value), p])
            ]);

              return Array.from(dedup.values());
            });

    };

    let hasFastTrackError = false;
    let keyDealerExists = null;
    let defaultMonths = 66;

    const setMissingSerial = (e) => {
        setIsMissingSerial(e);
        if (e) {
            setserialNumberSubmit("");
            setSerialNumberErrors(false);
            setSerialNumberClassName("");
        }
    }

    const setClaimTypeCallback = (e) => {
        setClaimTypeOptionError(false);
        const selectedOption = {
            value: e.target.value,
            name: e.target.options[e.target.selectedIndex].text
        }
        setClaimType(selectedOption);
    };

    const setClaimCredit = (setCredit) => {
        if (setCredit) {
            setClaimType({ value: '1', name: 'Credit' });
        }
        else {
            setClaimType("");
        }
    };

    const setAnalysisOnlyClaimType = () => {
        setClaimType({ value: '3', name: 'Analysis Only' });
    };

    const setPioneerItem = (e) => {
        setIsPioneerItem(e);
    };

    const setItemNumberSubmitCallback = (itemNumber) => {
        setObsolete(false);
        setItemNumberSubmit(itemNumber);
    };

    const setSerialNumberSubmit = (e) => {
        setDuplicateSerial(false);
        if (UserHelper.checkSpecialCharacters(e.target.value)) {
            setSerialNumberErrors(true);
            setSerialNumberClassName("warning-textbox");
        }
        else {
            setserialNumberSubmit(e.target.value);
            setSerialNumberErrors(false);
            setSerialNumberClassName("");
        }
    };

    const setDuplicateSerialCallback = (isDuplicate) => {
        setDuplicateSerial(isDuplicate);
    };

    const setSerialNumberWarningCallback = (isWarning) => {
        setSerialNumberWarning(isWarning);
    };

    const checkAllAreDigits = (value, index) => {
        if (value.length === 0) return true;
        if (!index) index = 0;
        if (isNaN(value[index])) return false;
        if (index === value.length - 1) return true;
        return checkAllAreDigits(value, ++index);
    };

    const setLoyaltyIDSubmitCallback = (e => {
        if (checkAllAreDigits(e.target.value)) {
            setLoyalityIDWarning({ isNumber: true, loyaltyID: null });
            setLoyaltyIDSubmit(e.target.value);
        }
        else {
            setLoyalityIDWarning({ isNumber: false, loyaltyID: null });
        }
        keyDealerExists = false;
    });

    const setDateInstalledSubmitCallback = (date) => {
        var formattedDate = DateHelper.format(date, dateFormat);
        setDateInstalledSubmit(formattedDate);
    };

    const setDateFailedSubmitCallback = (date) => {
        setDateFailedSubmit(DateHelper.format(date, dateFormat));
    };

    const setReferenceNumberSubmitCallback = (e) => {
        setReferenceNumberSubmit(e.target.value);
    };

    const validateFastTrack = async (itemNumber) => {
        try {
            const WarrantyFTReplacementBranch = props?.StorefrontConfig?.settingsList?.WarrantyFTReplacementBranch ?? null;
            setWarrantyAllowanceError(false);
            setIsMissingSerial(false);
            setFetching(true);
            const data = await ClaimService.fetchFastTrackStatus(itemNumber, props.selectedCustomer.billToId, WarrantyFTReplacementBranch);
            if (data?.itemNotFound) {
                Notifications.error(localized.ItemNotFound);
            }            
            const isEligibleForSerialNumberBypass = await checkIfItemNumberIsEligibleForValidation(itemNumber);
            const warrantyDetails=await ClaimService.getWarrantyMonths(itemNumber.trim(), loyaltyIDSubmit.trim());          
            setIsSerialNumberBypass(!!isEligibleForSerialNumberBypass);
            setItemNumberError(data?.itemNotFound ? true : false);
            setStockingType(data.stockingType);
            setReturnPolicy(data.returnPolicy);
            setObsolete(data.obsolete);
            setPioneerBrand(data.pioneerBrand);
            setIsPioneerItem(data.pioneerBrand && data.pioneerBrand.shown == true ? true : false);
            setDispositions(data);
            setProductType(data.productType);
            setWarrantyDescription(warrantyDetails.warrantyDescription); 
            setProductDescription(data.productDescription);
            if (data?.productType !== "Motor") {
                setPumpManufacturer("");
            }
            if (data && hasCustomerWarrantyAllowance && data.returnPolicy == 'F' && !UniqueWarrantyConstants.includes(itemNumber.toUpperCase())) {
                Notifications.error(validationResponseMessages["HasWarrantyAllowance"]);
                setWarrantyAllowanceError(true);
                setFetching(false);
                return
            }
        } catch (error) {
            console.error('Error validating fast track:', error);
        }
        setFetching(false);
    };

    const checkIfItemNumberIsEligibleForValidation = async (itemNumber) => {
        try {
            return await ClaimService.checkIfItemNeedsValidation(itemNumber);
        } catch (error) {
            console.error("Error checking if item number needs validation:", error);
            return false;
        }
    };

    const bypassFastTrackValidation = async (itemNumber, serialNumber) => {
        try {
            const WarrantyFTReplacementBranch = props?.StorefrontConfig?.settingsList?.WarrantyFTReplacementBranch ?? null;
            setWarrantyAllowanceError(false);
            var billTo = props.selectedCustomer.billToId;
            const data = await ClaimService.fetchFastTrackStatus(itemNumber, billTo, WarrantyFTReplacementBranch);
            var returnPolicyBypass;
            const serialYear = serialNumber.slice(0, 2);
            const serialMonth = serialNumber.slice(2, 3);
            const prior = ["A", "B", "C"];
            if ((serialYear == 24 && !prior.includes(serialMonth.toUpperCase()))
                || serialYear > 24) {
                returnPolicyBypass = ' ';
            }
            else {
                if (data && hasCustomerWarrantyAllowance && serialNumber.length >= 3) {
                    Notifications.error(validationResponseMessages["HasWarrantyAllowance"]);
                    setWarrantyAllowanceError(true);
                }
                returnPolicyBypass = "F";
            }
            setStockingType(data.stockingType);
            setReturnPolicy(returnPolicyBypass);
            setObsolete(data.obsolete);
            setPioneerBrand(data.pioneerBrand);
            setIsPioneerItem(data.pioneerBrand && data.pioneerBrand.shown == true ? true : false);
            data.returnPolicy = returnPolicyBypass;
            setDispositions(data);
            setProductType(data.productType);
            if (data?.productType !== "Motor") {
                setPumpManufacturer("");
            }
        } catch (error) {
            console.error('Error bypassing fast track validation:', error);
        }
    };

    const setDispositions = async (data) => {
        try {
            let stockingType = data.stockingType;
            const filterDispositions = allDispositions.warrantyClaimDisposition.filter(
                dt => dt.returnPolicy === data.returnPolicy
            );
            const comparator = (data.sku || data.itemNumber || "").toUpperCase();
            if (!data.returnPolicy || data.returnPolicy.trim() === "") {
                if (hasCustomerWarrantyAllowance && UniqueWarrantyConstants.includes(comparator)) {
                    setItemDispositions(filterDispositions.filter(al => al.id === 4));
                } else {
                    if (canApproveRejectClaim === false) {
                        setItemDispositions(filterDispositions.filter(al => al.id !== 4));
                    } else {
                        setItemDispositions(filterDispositions);
                    }
                }
            } else if (data.returnPolicy === 'F' && (stockingType === 'O' || stockingType === 'U')) {
                setItemDispositions(filterDispositions.filter(al => al.id === 1));
            } else {
                setItemDispositions(filterDispositions);
            }
        } catch (error) {
            console.error("An error occurred while filtering dispositions:", error);
            Notifications.error(localized.DispositionError);
        }
    };

    const checkFastTrackValidity = async (serialNumberUnformatted, itemNumber, checkSerial) => {
        let hasError = false;
        if (checkSerial) {
            const cleanSerialNumber = serialNumberUnformatted.replace(/[^0-9a-zA-Z]/g, '').trim();
            const monthLetters = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 9, K: 10, L: 11, M: 12 };
            const setError = (messageKey) => {
                Notifications.error(props.WarrantyConfig.labels[messageKey]);
                setFastTrackError(true);
                hasFastTrackError = hasError = true
            };
            if (cleanSerialNumber.length > 13) {
                setError('InvalidSerialNumber');
                return;
            }
            const serialPattern = /^\d{2}([ABCDEFGHJKLMabcdefghjklm]){1}([A-Za-z0-9]){2}[0-3]\d\d{5}[A-Za-z0-9]$/;
            if (!serialPattern.test(cleanSerialNumber)) {
                setError('InvalidSerialNumber');
                setSerialNumberErrors(true);
                return;
            }            
            const { warrantyMonths, keyDealerExists: loyaltyID } = await ClaimService.getWarrantyMonths(itemNumber.trim(), loyaltyIDSubmit.trim());           
            setLoyalityIDWarning({ ...loyalityIDWarning, loyaltyID });
            keyDealerExists = loyaltyID
            defaultMonths = warrantyMonths;
            const serialYear = parseInt(cleanSerialNumber.substring(0, 2), 10);
            const serialMonthChar = cleanSerialNumber.charAt(2).toUpperCase();
            const serialDay = parseInt(cleanSerialNumber.substring(5, 7), 10);
            const serialMonth = monthLetters[serialMonthChar];
            if (!serialMonth
                || serialYear <= 0
                || serialDay < 1
                || serialDay > 31) {
                setError('InvalidSerialNumber');
                return;
            }
            const currentYear = new Date().getFullYear();
            const currentCentury = Math.floor(currentYear / 100);
            const serialDate = new Date(`${currentCentury}${serialYear}`, serialMonth - 1, serialDay);
            const currentDate = new Date();
            if (serialDate > currentDate) {
                setError('InvalidSerialNumber');
                return;
            }
            const warrantyCutoffDate = new Date(serialDate);
            warrantyCutoffDate.setMonth(warrantyCutoffDate.getMonth() + warrantyMonths);            
            if (currentDate > warrantyCutoffDate) {
                Notifications.errorLong(props.WarrantyConfig.labels.SerialFastTrackAgeError);
                setFastTrackError(true);
                hasFastTrackError = hasError = true;
                return;
            }
        }
        const validationResponse = await ClaimService.checkValidity(itemNumberSubmit.trim(),
            checkSerial,
            serialNumberSubmit.trim(),
            props.selectedCustomer.billToId);
        const { statusMessage, recommendedItemNumber } = validationResponse;
        if (statusMessage === "IncorrectItemNumber") {
            Notifications.error(validationResponseMessages["InvalidSerialNumber"]);
            setIllegitimateSerialNumber(true);
            setRecommendedItemNumber(recommendedItemNumber);
            hasFastTrackError = hasError = true;
            return;
        }
        if (statusMessage === "InvalidSerialNumber") {
            Notifications.error(validationResponseMessages[statusMessage]);
            setIllegitimateSerialNumber(true);
            hasFastTrackError = hasError = true;
            return;
        }
        if (statusMessage === "ValidSerialNumber") {
            setIllegitimateSerialNumber(false);
            hasFastTrackError = hasError = false;
        }
        setFastTrackError(hasError);
        hasFastTrackError = hasError;
    };

    const checkSerialNumber = async (itemNumber) => {
        var serialNumber = serialNumberSubmit.trim();
        const isEligibleForValidation = await checkIfItemNumberIsEligibleForValidation(itemNumber);
        if (returnPolicy !== 'N' && props.WarrantyConfig.settings.ShowSerialNumberAlert) {
            if (isEligibleForValidation) {
                await checkFastTrackValidity(serialNumber, itemNumber, true);
            }
            else {
                await checkFastTrackValidity(serialNumber, itemNumber, false);
            }
        }
        // No duplicate serial numbers check for pioneer items. They comes in packing might have same serial numbers for multiple claims.
        if (serialNumber != "" && !isPioneerItem && !hasFastTrackError) {
            return await ClaimService.fetchWarrantySerialNumber(serialNumber)
                .then(data => {
                    if (data !== null) {
                        setSerialNumberClassName("unavailable");
                        setSerialNumberWarning(true);
                        Notifications.error(props.WarrantyConfig.labels.DuplicateSerialNumber);
                    }
                    else {
                        setSerialNumberClassName("");
                        setSerialNumberWarning(false);
                    }
                    return data;
                });
        } else {
            setSerialNumberErrors(true);
            setSerialNumberClassName("unavailable");
        }
    };

    const validateInstallFailureDate = () => {
        if (isPioneerItem) {
            return true;
        }
        const installDate = dateInstalledSubmit;
        const failureDate = dateFailedSubmit;
        if (!installDate || !failureDate) {
            return false;
        }
        const currentDate = new Date();
        const cutoffDate = DateHelper.subtract(currentDate, { months: 66 });
        const compareInstallDate = DateHelper.checkDateIsString(installDate, props.StorefrontConfig.settingsList.dateFormat);
        const compareFailureDate = DateHelper.checkDateIsString(failureDate, props.StorefrontConfig.settingsList.dateFormat);
        // Install Date can't be in the future
        if (DateHelper.compareDates(compareInstallDate, currentDate) === 1) {
            Notifications.error(localized.DateInTheFuture);
            setInstallDateError(true);
            return false;
        }
        // Failure Date can't be in the future
        if (DateHelper.compareDates(compareFailureDate, currentDate) === 1) {
            Notifications.error(localized.DateInTheFuture);
            setFailureDateError(true);
            return false;
        }
        // Install Date should be within the warranty period (cutoff date)
        if (DateHelper.compareDates(cutoffDate, compareInstallDate) === 1) {
            Notifications.error(localized.OutsideReturnPeriodError);
            setInstallDateError(true);
            return false;
        }
        // Failure Date should be on or after Install Date
        if (DateHelper.compareDates(compareInstallDate, compareFailureDate) === 1) {
            Notifications.error(localized.FailureDateBeforeInstallDate);
            setFailureDateError(true);
            return false;
        }
        setInstallDateError(false);
        setFailureDateError(false);
        return true;
    };

    const bypassDuplicateSerial = () => {
        if (!isEditMode) {
            return true;
        }
        const serialNumberIdentifier = serialNumberBeingEdited.split('-')[0];
        return !(serialNumberIdentifier === serialNumberSubmit);
    };

    const validateSubmission = async () => {
        const WarrantyFTReplacementBranch = props?.StorefrontConfig?.settingsList?.WarrantyFTReplacementBranch ?? null;
        const itemNumber = itemNumberSubmit.trim();
        if (!itemNumber) {
            setItemNumberError(true);
            return false;
        }
        let validData = true;
        let finalReturnPolicyForNonWarrantableVerification;
        if (isMissingSerial) {
            if (uploadFiles.length < 1) {
                Notifications.error(localized.UploadAttachmentRequired);
                return false;
            }
        }
        if (itemNumber !== "" && itemNumber !== null) {
            const policyData = await ClaimService.fetchFastTrackStatus(itemNumber, props.selectedCustomer.billToId, WarrantyFTReplacementBranch);
            finalReturnPolicyForNonWarrantableVerification = policyData.returnPolicy;
        }
        if (finalReturnPolicyForNonWarrantableVerification === "." || finalReturnPolicyForNonWarrantableVerification === "N") {
            validData = false;
        }
        let validSerialNumber;
        if (!isMissingSerial) {
            validSerialNumber = await checkSerialNumber(itemNumber);
        }
        if (hasWarrantyAllowanceError) {
            Notifications.error(validationResponseMessages["HasWarrantyAllowance"]);
            return false;
        }
        if (hasFastTrackError) {
            return false;
        }
        let serialNumber = serialNumberSubmit.trim();
        if (!isMissingSerial) {
            if (validSerialNumber != null) {
                validData = false;
            }
            if (claimLines.filter(o => o.serialNumber === serialNumber).length > 0 && bypassDuplicateSerial()) {
                setSerialNumberClassName("unavailable");
                setSerialNumberWarning(true);
                Notifications.error(props.WarrantyConfig.labels.DuplicateSerialNumber);
                validData = false;
            }
        }
        const validDate = validateInstallFailureDate();
        if (!validDate) {
            validData = false;
            return false;
        }
        if (keyDealerExists === false) {
            validData = false;
            return false;
        }
        return ClaimService.fetchWarrantyItemStatus(itemNumber.trim())
            .then(data => {
                if (data.sku === "" || data.sku === null) {
                    itemNumber = "";
                    validData = false;
                    Notifications.error("Invalid Item Number Entered");
                }
                setItemNumberError(itemNumber === "");
                // reference number is required
                let referenceNumber = referenceNumberSubmit.trim();
                setReferenceNumberError(referenceNumber === "");
                setClaimTypeOptionError(claimType === "");
                const validAdditonalComments = (failureType.isCommentsRequired && (detailsCommentSubmit == null || detailsCommentSubmit.trim() === ""));
                const isPumpManufacturerValid = productType === "Motor" ? pumpManufacturer !== "" : true;
                // pioneer warranty validation rules
                if (isPioneerItem === true) {
                    if (pioneerBrand && pioneerBrand.required == true) {
                        return !(
                            itemNumber === ""
                            || referenceNumber === ""
                            || (serialNumber === "" && !isMissingSerial)
                            || failureType.selected === ""
                            || !isPumpManufacturerValid
                            || validAdditonalComments);
                    }
                    else {
                        return !(
                            itemNumber === ""
                            || referenceNumber === ""
                            || failureType.selected === ""
                            || !isPumpManufacturerValid
                            || validAdditonalComments);
                    }
                }
                var isValid = !(
                    itemNumber === ""
                    || claimType === ""
                    || referenceNumber === ""
                    || (serialNumber === "" && !isMissingSerial)
                    || failureType.selected === ""
                    || !isPumpManufacturerValid
                    || validAdditonalComments) && validData;
                return isValid;
            });
    };

    const validatePioneerItem = (itemNumber, comments, referenceNumber, serialNumber) => {
        if (pioneerBrand && pioneerBrand.shown === true && pioneerBrand.required == true) {
            var isValidPioneerSnoItem = !(
                itemNumber === ""
                || comments === ""
                || referenceNumber === ""
                || serialNumber === "");
            return isValidPioneerSnoItem;
        }
        else {
            var isValidPioneerItem = !(
                itemNumber === ""
                || comments === ""
                || referenceNumber === "");
            return isValidPioneerItem;
        }
    };

    const removeClaimItem = (key) => {
        const updatedClaimLines = [...claimLines];
        const index = updatedClaimLines.findIndex(o => o.key === key);
        updatedClaimLines.splice(index, 1);
        // Clearing off the duplicate serial numbers validation message on claim submission.
        const validClaimLine = updatedClaimLines.filter((o) => o.isValid === false);
        if (validClaimLine?.length === 0) {
            setIsValidClaim(false);
        }
        setClaimLines(updatedClaimLines);
    };

    const loadClaimLineItemForEdit = (key) => {
        setIsEditMode(true);
        setAddingItem(false);
        // Find the claim line to edit
        const index = claimLines.findIndex(o => o.key === key);
        const claimLine = claimLines[index];
        setSerialNumberBeingEdited(key);
        // Fill the form with the claim line data
        setDetailsCommentSubmit(claimLine.detailsComments);
        setItemNumberSubmit(claimLine.itemNumber);
        setserialNumberSubmit(claimLine.serialNumber);
        setDateInstalledSubmit(new Date(claimLine.dateInstalled));
        setDateFailedSubmit(new Date(claimLine.dateFailed));
        setReferenceNumberSubmit(claimLine.referenceNumber);
        setLoyaltyIDSubmit(claimLine.loyaltyID);
        setClaimType(claimLine.claimType);
        setObsolete(claimLine.obsolete);
        setPioneerBrand(claimLine.pioneerBrand);
        setIsPioneerItem(claimLine.isPioneerItem);
        setStockingType(claimLine.stockingType);
        setReturnPolicy(claimLine.returnPolicy);
        setUploadFiles([...claimLine.uploadFiles]);
        setFullName(claimLine.fullName);
        setEmailAddress(claimLine.emailAddress);
        setCustomerNumber(claimLine.customerNumber);
        setBranchPlant(claimLine.branchPlant);
        setPumpManufacturer(claimLine.pumpManufacturer);
        setIsMissingSerial(claimLine.isMissingSerial);
        setIsSerialNumberBypass(claimLine.isSerialNumberBypass);
        setFailureType({ selected: claimLine.failureType, isCommentsRequired: claimLine.isCommentsRequired });
        // Load dispositions
        setDispositions(claimLine);
    };

    const setShowModal = showModal => {
        setShowNonFastTrackModal(showModal);
    };

    const addClaimItem = async () => {
        setAddingItem(true);
        const valid = await validateSubmission();
        if (valid) {
            saveClaimItem();
        }
        setAddingItem(false);
        return valid;
    };

    const editClaimItem = async () => {
        try {
            if (!isEditMode) {
                return;
            }
            setAddingItem(true);
            const isValid = await validateSubmission();
            if (!isValid) {
                setAddingItem(false);
                return false;
            }
            removeClaimItem(serialNumberBeingEdited);
            saveClaimItem();
            setAddingItem(false);
            return true;
        } catch (error) {
            console.error('Error editing claim item:', error);
            return false;
        }
    };

    const clearForm = () => {
        setDetailsCommentSubmit("");
        setItemNumberSubmit("");
        setserialNumberSubmit("");
        setDateFailedSubmit(null);
        setDateInstalledSubmit(null);
        setReferenceNumberSubmit("");
        setLoyaltyIDSubmit("");
        setFastTrackError("");
        setClaimType("");
        setObsolete(false);
        setPioneerBrand("");
        setIsPioneerItem(false);
        setStockingType("");
        setReturnPolicy("");
        setUploadFiles([]);
        setFullName("");
        setEmailAddress("");
        setCustomerNumber("");
        setBranchPlant("");
        setSerialNumberBeingEdited(null);
        setIsEditMode(false);
        setPumpManufacturer("");
        setFailureType({ selected: "", isCommentsRequired: true });
        setProductDescription("");
        setIsMissingSerial(false);
        setIsSerialNumberBypass(false);
        keyDealerExists = null;
        defaultMonths = 66;
        setRecommendedItemNumber(null);
        setWarrantyDescription("");
    };

    const submitClaim = () => {
        let nonFastTrackClaims = claimLines.filter(item => item.fastTrack !== true);
        if (nonFastTrackClaims.length > 0) {
            setShowModal(true);
        }
        else {
            executeSubmit();
        }
    };

    const executeSubmit = async (nftClaims) => {
        let fastTrackClaims = claimLines.filter(item => item.fastTrack === true);
        let nonFastTrackClaims = nftClaims ? nftClaims : claimLines.filter(item => item.fastTrack !== true);
        setFetching(true);
        setShowNonFastTrackModal(false);
        // Validate serial numbers on claim submission.
        let validatedClaimLines = await ClaimService.validateClaim([...fastTrackClaims, ...nonFastTrackClaims]).then(data => {
            if (data) return data;
        });
        // Submit claims only if all the items are valid(no duplicates)
        let valid = validatedClaimLines?.filter(o => o.isValid == false);
        if (valid?.length === 0) {
            setIsValidClaim(false);
            submitClaimToAPI([...fastTrackClaims, ...nonFastTrackClaims]);
        }
        else {
            setFetching(false);
            setIsValidClaim(true);
            setClaimLines(validatedClaimLines);
            Notifications.errorShow(localized.DuplicateClaimSubmission);
        }
    };

    const claimFailureResponse = () => {
        setFetching(false);
        Notifications.errorShow(localized.ClaimSubmitError);
        setClaimLines([]);
        setIsClaimSubmitted(true);
    };

    const claimSuccessResponse = () => {
        Notifications.message(localized.ClaimSubmitted);
        fetchClaims();
        setIsClaimSubmitted(true);
    };

    const uploadClaimAttachments = (files, claimLine) => {
        const claimsAttachmentsToUpload = claimLines.map(claim => {
            if (claim === claimLine) {
                return {
                    ...claim,
                    uploadFiles: [...files]
                }
            }
            else {
                return { ...claim }
            }
        });
        setClaimLines(claimsAttachmentsToUpload);
    };

    const uploadClaimAttachmentsToLocalClaimItem = (files) => {
        setUploadFiles([...files]);
    };

    const submitClaimWithoutAttachmentsToAPI = async (claimsWithoutAttachments) => {
        if (claimsWithoutAttachments.length > 0) {
            try {
                const res = await ClaimService.submitClaim(claimsWithoutAttachments);
                if (res) {
                    Notifications.message(localized.ClaimSubmitted);
                    await fetchClaims();
                    setClaimLines([]); // TODO: handle failure scenarios
                    setIsClaimSubmitted(true);
                } else {
                    claimFailureResponse();
                }
            } catch (error) {
                console.error("Error submitting claims: ", error);
                claimFailureResponse();
            }
        }
    };

    const submitClaimWithAttachmentsToAPI = (claimsWithAttachments) => {
        const claimsWithoutAttachments = claimLines.filter(item => item.uploadFiles?.length == 0);
        if (claimsWithAttachments.length > 0) {
            claimsWithAttachments.map(cl => {
                ClaimService.submitClaimWithAttachment(cl).then(res => {
                    if (res !== undefined) {
                        if (claimsWithoutAttachments.length == 0) { // avoid multiple toasts
                            claimSuccessResponse();
                            let removeClaimLine = claimsWithAttachments.filter(o => o.serialNumber != cl.serialNumber);
                            setClaimLines(removeClaimLine);
                        }
                        const caseNumber = Array.isArray(res) && res.length > 0 ? res[0]["Case Number"] ?? null : null;
                        if (!caseNumber) {
                            console.error("Case number is missing in the response.");
                            Notifications.error(localized.AttachmentError);
                            return;
                        }
                        let modifiedUploadFiles = [];
                        cl.uploadFiles.forEach((file, index) => {
                            var fileExtension = file.name.split('.').pop();
                            var newFileName = `${caseNumber}-${cl.customerNumber}-${index + 1}.${fileExtension}`;
                            modifiedUploadFiles.push(new File([file], newFileName, { type: file.type }));
                        });
                        ClaimService.uploadAttachment(modifiedUploadFiles, caseNumber, cl.customerNumber).then(response => {
                            if (response) {
                                Notifications.message(localized.AttachmentSubmitted);
                            }
                            else {
                                Notifications.error(localized.AttachmentError);
                            }
                        })
                    } else {
                        if (claimsWithoutAttachments.length == 0) {
                            claimFailureResponse();
                        }
                    }
                });
            });
        }
    };

    const submitClaimToAPI = (claimLines) => {
        let claimsWithAttachments = claimLines.filter(item => item.uploadFiles?.length > 0);
        let claimsWithoutAttachments = claimLines.filter(item => item.uploadFiles?.length == 0);
        submitClaimWithAttachmentsToAPI(claimsWithAttachments);
        submitClaimWithoutAttachmentsToAPI(claimsWithoutAttachments);
    };

    const handleEnter = (e) => {
        if (e.key === "Enter")
            addClaimItem();
    };

    const setClaimApprovalCallback = (caseNumber, e) => {
        const claimsApprovalData = claims.map(claim => {
            if (claim.caseNumber === caseNumber) {
                return {
                    ...claim,
                    approvalStatus: e.target.value
                }
            }
            else {
                return { ...claim }
            }
        });
        setClaims(claimsApprovalData);
        const filterData = claimsApprovalData.filter(o => o.approvalStatus);
        setClaimApproval(filterData);
    };

    const saveChangesClaimApproval = async () => {
        const approvalClaims = claimApproval;
        if (canApproveRejectClaim && approvalClaims.length > 0) {
            setFetching(true);
            for (const claim of approvalClaims) {
                const data = {
                    caseNumber: claim.caseNumber.toString(),
                    approved: claim.approvalStatus === "1" ? "true" : "false",
                    fileName: `${claim.billToCustomer}-${claim.rmA_PONumber}${claim.documentType}`,
                    customerId: customerId,
                    fullName: `${props.currentUser.firstName} ${props.currentUser.lastName}`,
                    emailAddress: props.currentUser.email
                };
                try {
                    const res = await ClaimService.claimApproval(data, customerId);
                    if (res) {
                        data.approved === "true"
                            ? Notifications.message(localized.ClaimApproved)
                            : Notifications.message(localized.ClaimRejected);
                    } else {
                        Notifications.error(localized.ClaimApprovalError);
                    }
                } catch (error) {
                    Notifications.error(localized.ClaimApprovalError);
                }
            }
            await fetchClaims();
        }
    };

    const saveClaimItem = () => {
        var lineNumber;
        var fastTrackValid = returnPolicy;
        if (fastTrackValid === 'F') {
            let fastTrackClaimLines = claimLines.filter(item => item.fastTrack === true && item.claimType.value === "1");// Credit
            var newLineIndex = fastTrackClaimLines.length + 1;
            lineNumber = newLineIndex.toFixed(2);
        }
        if (hasFastTrackError == false) {
            let newClaimLine = {
                comments: failureType.selected, // Note: Has maximum character length 25 from previous logic
                detailsComments: detailsCommentSubmit,
                itemNumber: itemNumberSubmit,
                serialNumber: serialNumberSubmit,
                dateInstalled: DateHelper.format(dateInstalledSubmit, dateFormat),
                dateFailed: DateHelper.format(dateFailedSubmit, dateFormat),
                referenceNumber: referenceNumberSubmit,
                loyaltyID: loyaltyIDSubmit,
                rmaLineNumber: lineNumber,
                fastTrack: (fastTrackValid === 'F'),
                claimType: claimType,
                fullName: props.currentUser.firstName + ' ' + props.currentUser.lastName,
                emailAddress: props.currentUser.email,
                customerNumber: customerId,
                billToCustomer: billToCustomer,
                branchPlant: props.currentUser.storefrontNumber,
                returnConfirmation: true,
                stockingType: stockingType,
                obsolete: obsolete,
                pioneerBrand: pioneerBrand,
                isPioneerItem: isPioneerItem,
                uploadFiles: uploadFiles,
                returnPolicy: returnPolicy,
                pumpManufacturer: pumpManufacturer,
                failureType: failureType.selected,
                isCommentsRequired: failureType.isCommentsRequired,
                isMissingSerial: isMissingSerial,
                isSerialNumberBypass: isSerialNumberBypass,
                key: serialNumberSubmit + - + new Date().getTime(),
            };
            setClaimLines((prevState) => ([...prevState, newClaimLine]));
            clearForm();
        }
    }

    const renderClaimSubmission = () => {
        return (
            <ClaimsSubmission
                UniqueWarrantyConstants={UniqueWarrantyConstants}
                setDetailsCommentSubmit={setDetailsCommentSubmit}
                detailsCommentSubmit={detailsCommentSubmit}
                setItemNumberSubmit={setItemNumberSubmitCallback}
                setSerialNumberSubmit={setSerialNumberSubmit}
                setDateInstalledSubmit={setDateInstalledSubmitCallback}
                setDateFailedSubmit={setDateFailedSubmitCallback}
                setReferenceNumberSubmit={setReferenceNumberSubmitCallback}
                setLoyaltyIDSubmit={setLoyaltyIDSubmitCallback}
                setSerialNumberWarning={setSerialNumberWarningCallback}
                setClaimCredit={setClaimCredit}
                setDuplicateSerial={setDuplicateSerialCallback}
                itemNumberSubmit={itemNumberSubmit}
                serialNumberSubmit={serialNumberSubmit}
                dateInstalledSubmit={dateInstalledSubmit}
                dateFailedSubmit={dateFailedSubmit}
                referenceNumberSubmit={referenceNumberSubmit}
                loyaltyIDSubmit={loyaltyIDSubmit}
                removeClaimItem={removeClaimItem}
                uploadFiles={uploadFiles}
                uploadClaimAttachments={uploadClaimAttachments}
                uploadClaimAttachmentsToLocalClaimItem={
                    uploadClaimAttachmentsToLocalClaimItem
                }
                isMissingSerial={isMissingSerial}
                setMissingSerial={setMissingSerial}
                addClaimItem={addClaimItem}
                addingItem={addingItem}
                validateFastTrack={validateFastTrack}
                checkIfItemNumberIsEligibleForValidation={checkIfItemNumberIsEligibleForValidation}
                bypassFastTrackValidation={bypassFastTrackValidation}
                submitClaim={submitClaim}
                claimLines={claimLines}
                handleEnter={handleEnter}
                dateFormat={props.StorefrontConfig.settingsList.dateFormat}
                itemNumberError={itemNumberError}
                installDateError={installDateError}
                failureDateError={failureDateError}
                serialNumberWarning={serialNumberWarning}
                loyalityIDWarning={loyalityIDWarning}
                referenceNumberError={referenceNumberError}
                setClaimType={setClaimTypeCallback}
                claimType={claimType}
                claimTypeOptionError={claimTypeOptionError}
                serialNumberClassName={serialNumberClassName}
                stockingType={stockingType}
                returnPolicy={returnPolicy}
                obsolete={obsolete}
                duplicateSerial={duplicateSerial}
                claims={claims}
                serialNumberErrors={serialNumberErrors}
                fetching={fetching}
                canApproveRejectClaim={canApproveRejectClaim}
                isValidClaim={isValidClaim}
                pioneerBrand={pioneerBrand}
                isPioneerItem={isPioneerItem}
                setAnalysisOnlyClaimType={setAnalysisOnlyClaimType}
                setPioneerItem={setPioneerItem}
                itemDispositions={itemDispositions}
                locale={props.StorefrontConfig.locale}
                loadClaimLineItemForEdit={loadClaimLineItemForEdit}
                isEditMode={isEditMode}
                editClaimItem={editClaimItem}
                clearForm={clearForm}
                productType={productType}
                pumpManufacturer={pumpManufacturer}
                setPumpManufacturer={setPumpManufacturer}
                failureType={failureType}
                setFailureType={setFailureType}
                productDescription={productDescription}
                illegitimateSerialNumber={illegitimateSerialNumber}
                serialNumberBeingEdited={serialNumberBeingEdited}
                recommendedItemNumber={recommendedItemNumber}
                isSerialNumberBypass={isSerialNumberBypass}
                warrantyDescription={warrantyDescription}
            />
        );
    };

    const renderClaimFilter = () => (
        <ClaimsFilter
            fromFullDate={fromFullDate}
            toFullDate={toFullDate}
            totalCount={count ?? 0}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            rowsPerPageOptions={[10, 25, 50, 100]}
            setFromDate={(d) => { setFromFullDate(d); setPaginationModel(pm => ({ ...pm, page: 0 })); }}
            setToDate={(d) => { setToFullDate(d); setPaginationModel(pm => ({ ...pm, page: 0 })); }}
            setStatus={(arr) => {
                const normalized = (arr || []).map(s => ({
                    label: String(s?.label ?? s?.description ?? s?.value ?? s ?? ''),
                    value: String(s?.value ?? s?.description ?? s?.label ?? s ?? ''),
                }));
                setSelectedStatuses(normalized);
                setPaginationModel(pm => ({ ...pm, page: 0 }));
            }}
            setNumber={(value) => { setNumberFilter(value ?? ''); setPaginationModel(pm => ({ ...pm, page: 0 })); }}
            listView={listView}
            fetchClaims={fetchClaims}
            resetFilters={() => {
                setFromFullDate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
                setToFullDate(new Date());
                setSelectedStatuses([]);
                setNumberFilter('');
                setPaginationModel(pm => ({ ...pm, page: 0 }));
            }}
            saveChangesClaimApproval={saveChangesClaimApproval}
            localized={props.WarrantyConfig.labels}
            availableStatuses={availableStatuses}
            selectedStatuses={selectedStatuses}
            numberFilter={numberFilter}
        />
    );

    const renderClaims = () => {
        const hasSubmit = props.currentUser.roles.includes(Roles.SUBMIT_CLAIM);
        const hasShipToOrBothAddressType = UserHelper.checkCustomerAddressType(props.selectedCustomer.addressType);
        return (
            <div>
                {hasSubmit && hasShipToOrBothAddressType && renderClaimSubmission()}

                {isClaimSubmitted && props.WarrantyConfig.settings.ShowSurvey ? (
                    <Survey localized={localized} feature={feature} />
                ) : null}

                <div>
                    {!hasShipToOrBothAddressType && (
                        <NotificationBanner
                            classOverride="mb-4"
                            page="ClaimHistory"
                            locale={props.StorefrontConfig.locale}
                        />
                    )}
                    {renderClaimFilter()}
                </div>
                <Claims
                    claims={claims || []}
                    fetching={fetching}
                    count={count ?? 0}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    listView={listView}
                    localized={props.WarrantyConfig.labels}
                    roles={props.currentUser.roles}
                    statusCodes={Array.isArray(statusCodes) ? statusCodes : []}
                    claimsStatus={Array.isArray(claimsStatus) ? claimsStatus : []}
                    setClaimApproval={setClaimApprovalCallback}
                />
            </div>
        );
    };

    const { selectedCustomer } = props;

    return (
        <React.Fragment>
            {showNonFastTrackModal &&
                <NonFastTrackModal
                    setShowModal={setShowModal}
                    claims={claimLines}
                    addNonFastTrackFields={executeSubmit}
                ></NonFastTrackModal>
            }

            {selectedCustomer &&
                <React.Fragment>
                    {renderClaims()}
                </React.Fragment>
            }
        </React.Fragment>
    );
};

ClaimHistory.propTypes = {
    selectedCustomer: PropTypes.object,
    currentUser: PropTypes.object,
    dateFormat: PropTypes.string
}

function mapStateToProps(state) {
    return {
        selectedCustomer: state.user.selectedCustomer,
        currentUser: state.user.currentUser,
    };
}

export default connect(
    mapStateToProps,
    null
)(withWarrantyConfig(withStorefrontConfig(withSelectedCustomer(ClaimHistory))));
